<template>
  <div class="AboutUs">
    <menuBox :step="2"></menuBox>
    <div class="about-us">
      About Us
    </div>

    <div class="caslno">
      <div class="title">{{ $t('about_19') }}</div>
      <div class="sbtitle">{{ $t('about_20') }}</div>
      <div class="caslno-list">
        <div class="caslno-item">
          <img src="../assets/icon-1.png" alt="">
          <div class="caslno-text">
            <div>{{ $t('about_21') }}</div>
            <p>{{ $t('about_22') }}</p>
          </div>
        </div>

        <div class="caslno-item">
          <img src="../assets/icon-2.png" alt="">
          <div class="caslno-text">
            <div>{{ $t('about_23') }}</div>
            <p>{{ $t('about_24') }}</p>
          </div>
        </div>

        <div class="caslno-item">
          <img src="../assets/icon-3.png" alt="">
          <div class="caslno-text">
            <div>{{ $t('about_25') }}</div>
            <p>{{ $t('about_26') }}</p>
          </div>
        </div>

        <div class="caslno-item">
          <img src="../assets/icon-4.png" alt="">
          <div class="caslno-text">
            <div>{{ $t('about_27') }}</div>
            <p>{{ $t('about_28') }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="asked">
      <div class="title">{{ $t('about_1') }}</div>
      <div class="sbtitle">{{ $t('about_2') }}</div>
      <div class="ask-list">
        <div class="ask-item">
          <div class="ask-title" @click="ask_1 = !ask_1">
            {{ $t('about_3') }}
            <div class="img-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <g clip-path="url(#clip0_310_8354)">
                  <path d="M7.95977 12.5204L15.7595 4.717C16.0445 4.43245 16.0424 3.9724 15.7552 3.68998C15.6168 3.55429 15.4304 3.47865 15.2366 3.47944C15.0427 3.48024 14.857 3.55742 14.7197 3.69424L7.9635 10.4536L1.25412 3.69636C1.11743 3.55879 0.931934 3.48076 0.738002 3.47927C0.544069 3.47778 0.357394 3.55293 0.218597 3.68838C0.1501 3.75499 0.0955082 3.83453 0.0579875 3.92239C0.0204667 4.01025 0.0007639 4.10469 2.17761e-05 4.20023C-0.000720348 4.29576 0.017513 4.39049 0.0536642 4.47893C0.0898155 4.56736 0.143165 4.64774 0.210619 4.7154L7.95977 12.5204Z" fill="#333333" />
                </g>
                <defs>
                  <clipPath id="clip0_310_8354">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <p v-if="ask_1">{{ $t('about_4') }}</p>
        </div>

        <div class="ask-item">
          <div class="ask-title" @click="ask_2 = !ask_2">
            {{ $t('about_5') }}
            <div class="img-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <g clip-path="url(#clip0_310_8354)">
                  <path d="M7.95977 12.5204L15.7595 4.717C16.0445 4.43245 16.0424 3.9724 15.7552 3.68998C15.6168 3.55429 15.4304 3.47865 15.2366 3.47944C15.0427 3.48024 14.857 3.55742 14.7197 3.69424L7.9635 10.4536L1.25412 3.69636C1.11743 3.55879 0.931934 3.48076 0.738002 3.47927C0.544069 3.47778 0.357394 3.55293 0.218597 3.68838C0.1501 3.75499 0.0955082 3.83453 0.0579875 3.92239C0.0204667 4.01025 0.0007639 4.10469 2.17761e-05 4.20023C-0.000720348 4.29576 0.017513 4.39049 0.0536642 4.47893C0.0898155 4.56736 0.143165 4.64774 0.210619 4.7154L7.95977 12.5204Z" fill="#333333" />
                </g>
                <defs>
                  <clipPath id="clip0_310_8354">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <p v-if="ask_2">{{ $t('about_6') }}</p>
        </div>

        <div class="ask-item">
          <div class="ask-title" @click="ask_3 = !ask_3">
            {{ $t('about_7') }}
            <div class="img-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <g clip-path="url(#clip0_310_8354)">
                  <path d="M7.95977 12.5204L15.7595 4.717C16.0445 4.43245 16.0424 3.9724 15.7552 3.68998C15.6168 3.55429 15.4304 3.47865 15.2366 3.47944C15.0427 3.48024 14.857 3.55742 14.7197 3.69424L7.9635 10.4536L1.25412 3.69636C1.11743 3.55879 0.931934 3.48076 0.738002 3.47927C0.544069 3.47778 0.357394 3.55293 0.218597 3.68838C0.1501 3.75499 0.0955082 3.83453 0.0579875 3.92239C0.0204667 4.01025 0.0007639 4.10469 2.17761e-05 4.20023C-0.000720348 4.29576 0.017513 4.39049 0.0536642 4.47893C0.0898155 4.56736 0.143165 4.64774 0.210619 4.7154L7.95977 12.5204Z" fill="#333333" />
                </g>
                <defs>
                  <clipPath id="clip0_310_8354">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <p v-if="ask_3">{{ $t('about_8') }}</p>
        </div>

        <div class="ask-item">
          <div class="ask-title" @click="ask_4 = !ask_4">
            {{ $t('about_9') }}
            <div class="img-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <g clip-path="url(#clip0_310_8354)">
                  <path d="M7.95977 12.5204L15.7595 4.717C16.0445 4.43245 16.0424 3.9724 15.7552 3.68998C15.6168 3.55429 15.4304 3.47865 15.2366 3.47944C15.0427 3.48024 14.857 3.55742 14.7197 3.69424L7.9635 10.4536L1.25412 3.69636C1.11743 3.55879 0.931934 3.48076 0.738002 3.47927C0.544069 3.47778 0.357394 3.55293 0.218597 3.68838C0.1501 3.75499 0.0955082 3.83453 0.0579875 3.92239C0.0204667 4.01025 0.0007639 4.10469 2.17761e-05 4.20023C-0.000720348 4.29576 0.017513 4.39049 0.0536642 4.47893C0.0898155 4.56736 0.143165 4.64774 0.210619 4.7154L7.95977 12.5204Z" fill="#333333" />
                </g>
                <defs>
                  <clipPath id="clip0_310_8354">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <p v-if="ask_4">{{ $t('about_10') }}</p>
        </div>

        <div class="ask-item">
          <div class="ask-title" @click="ask_5 = !ask_5">
            {{ $t('about_11') }}
            <div class="img-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <g clip-path="url(#clip0_310_8354)">
                  <path d="M7.95977 12.5204L15.7595 4.717C16.0445 4.43245 16.0424 3.9724 15.7552 3.68998C15.6168 3.55429 15.4304 3.47865 15.2366 3.47944C15.0427 3.48024 14.857 3.55742 14.7197 3.69424L7.9635 10.4536L1.25412 3.69636C1.11743 3.55879 0.931934 3.48076 0.738002 3.47927C0.544069 3.47778 0.357394 3.55293 0.218597 3.68838C0.1501 3.75499 0.0955082 3.83453 0.0579875 3.92239C0.0204667 4.01025 0.0007639 4.10469 2.17761e-05 4.20023C-0.000720348 4.29576 0.017513 4.39049 0.0536642 4.47893C0.0898155 4.56736 0.143165 4.64774 0.210619 4.7154L7.95977 12.5204Z" fill="#333333" />
                </g>
                <defs>
                  <clipPath id="clip0_310_8354">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <p v-if="ask_5">{{ $t('about_12') }}</p>
        </div>

        <div class="ask-item">
          <div class="ask-title" @click="ask_6 = !ask_6">
            {{ $t('about_13') }}
            <div class="img-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <g clip-path="url(#clip0_310_8354)">
                  <path d="M7.95977 12.5204L15.7595 4.717C16.0445 4.43245 16.0424 3.9724 15.7552 3.68998C15.6168 3.55429 15.4304 3.47865 15.2366 3.47944C15.0427 3.48024 14.857 3.55742 14.7197 3.69424L7.9635 10.4536L1.25412 3.69636C1.11743 3.55879 0.931934 3.48076 0.738002 3.47927C0.544069 3.47778 0.357394 3.55293 0.218597 3.68838C0.1501 3.75499 0.0955082 3.83453 0.0579875 3.92239C0.0204667 4.01025 0.0007639 4.10469 2.17761e-05 4.20023C-0.000720348 4.29576 0.017513 4.39049 0.0536642 4.47893C0.0898155 4.56736 0.143165 4.64774 0.210619 4.7154L7.95977 12.5204Z" fill="#333333" />
                </g>
                <defs>
                  <clipPath id="clip0_310_8354">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <p v-if="ask_6">{{ $t('about_14') }}</p>
        </div>

        <div class="ask-item">
          <div class="ask-title" @click="ask_7 = !ask_7">
            {{ $t('about_15') }}
            <div class="img-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <g clip-path="url(#clip0_310_8354)">
                  <path d="M7.95977 12.5204L15.7595 4.717C16.0445 4.43245 16.0424 3.9724 15.7552 3.68998C15.6168 3.55429 15.4304 3.47865 15.2366 3.47944C15.0427 3.48024 14.857 3.55742 14.7197 3.69424L7.9635 10.4536L1.25412 3.69636C1.11743 3.55879 0.931934 3.48076 0.738002 3.47927C0.544069 3.47778 0.357394 3.55293 0.218597 3.68838C0.1501 3.75499 0.0955082 3.83453 0.0579875 3.92239C0.0204667 4.01025 0.0007639 4.10469 2.17761e-05 4.20023C-0.000720348 4.29576 0.017513 4.39049 0.0536642 4.47893C0.0898155 4.56736 0.143165 4.64774 0.210619 4.7154L7.95977 12.5204Z" fill="#333333" />
                </g>
                <defs>
                  <clipPath id="clip0_310_8354">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <p v-if="ask_7">{{ $t('about_16') }}</p>
        </div>

        <div class="ask-item">
          <div class="ask-title" @click="ask_8 = !ask_8">
            {{ $t('about_17') }}
            <div class="img-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <g clip-path="url(#clip0_310_8354)">
                  <path d="M7.95977 12.5204L15.7595 4.717C16.0445 4.43245 16.0424 3.9724 15.7552 3.68998C15.6168 3.55429 15.4304 3.47865 15.2366 3.47944C15.0427 3.48024 14.857 3.55742 14.7197 3.69424L7.9635 10.4536L1.25412 3.69636C1.11743 3.55879 0.931934 3.48076 0.738002 3.47927C0.544069 3.47778 0.357394 3.55293 0.218597 3.68838C0.1501 3.75499 0.0955082 3.83453 0.0579875 3.92239C0.0204667 4.01025 0.0007639 4.10469 2.17761e-05 4.20023C-0.000720348 4.29576 0.017513 4.39049 0.0536642 4.47893C0.0898155 4.56736 0.143165 4.64774 0.210619 4.7154L7.95977 12.5204Z" fill="#333333" />
                </g>
                <defs>
                  <clipPath id="clip0_310_8354">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <p v-if="ask_8">{{ $t('about_18') }}</p>
        </div>

      </div>
    </div>

    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      ask_1: false,
      ask_2: false,
      ask_3: false,
      ask_4: false,
      ask_5: false,
      ask_6: false,
      ask_7: false,
      ask_8: false,
    };
  },
  mounted() { },
  methods: {},
};
</script>

<style lang="less" scoped>
.title {
  color: #E51359;
  text-align: center;
  font-family: Helvetica;
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: capitalize;
}

.sbtitle {
  color: #333;
  text-align: center;
  font-family: Helvetica;
  font-size: 18px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  text-transform: capitalize;
  margin-top: 32px;
}

.about-us {
  color: #FFF;
  text-align: center;
  font-family: Helvetica;
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: capitalize;
  padding: 115px;
  text-align: center;
}

.caslno {
  background-color: #FFF;
  position: relative;
  padding-top: 200px;
  padding: 100px 300px;

  .caslno-list {
    display: flex;
    justify-content: space-between;
    margin-top: 80px;
    flex-wrap: wrap;

    .caslno-item {
      display: flex;
      justify-content: space-between;
      width: 520px;
      height: 92px;
      flex-shrink: 0;
      background-color: #F5F6F8;
      border-radius: 20px;
      padding: 50px;
      margin-bottom: 20px;

      img {
        width: 50px;
        height: 50px;
        margin-right: 20px;
      }

      .caslno-text {
        width: 426px;

        div {
          color: #333;
          font-family: Helvetica;
          font-size: 24px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          text-transform: capitalize;
        }

        p {
          color: #333;
          font-family: Helvetica;
          font-size: 16px;
          font-style: normal;
          font-weight: 300;
          line-height: normal;
          text-transform: capitalize;
          margin-top: 16px;
        }
      }
    }

  }
}

.asked {
  background: #F5F6F8;
  padding: 100px 300px;

  .ask-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 80px;

    .ask-item {
      width: 590px;
      min-height: 0px;
      flex-shrink: 0;
      padding: 25px;
      background-color: #FFF;
      border-radius: 20px;
      margin-bottom: 20px;

      .ask-title {
        color: #E51359;
        font-family: Helvetica;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .img-box {
          width: 16px;
          height: 16px;
          flex-shrink: 0;
        }
      }

      p {
        color: #333;
        font-family: Helvetica;
        font-size: 16px;
        font-style: normal;
        font-weight: 300;
        margin-top: 16px;
      }
    }
  }
}
</style>
